import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaQuadroInativosADMRH: ['referencia'],
    limpaFiltroConsultaQuadroInativosADMRH: [],
    receberFiltroConsultaQuadroInativosADMRH: ['filtroRecebido'],
    setStatusConsultaQuadroInativosADMRH: ['status'],
})

const INITIAL_STATE = {
    referencia: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_QUADRO_INATIVOS_ADMRH]: setReferencia,
    [Types.LIMPA_FILTRO_CONSULTA_QUADRO_INATIVOS_ADMRH]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_QUADRO_INATIVOS_ADMRH]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_QUADRO_INATIVOS_ADMRH]: setStatus,
})
